/// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class MiniCartViewModel extends Tapas.ViewModels.CartViewModel {
        public ShowEmptyMiniCart: KnockoutComputed<boolean>;
        public ShowCartIndicator: KnockoutComputed<boolean>;
        constructor() {            
            super();
            this.CartDataService.GetCurrent();

            this.ShowEmptyMiniCart = ko.computed({
                owner: this,
                read: () => {
                    return this.Cart().TotalProductLines() == 0 ? false : true;
                }
            });   

			this.ShowCartIndicator = ko.computed({
				owner: this,
				read: () => {
					return this.Cart().TotalProductLines() == 0 ? false : true;
				}
            });   
        }      
    }
}